import { useGrowthBook } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { useTranslation } from 'next-i18next/pages'

export const useMediaLogosVariant = () => {
  const { i18n } = useTranslation()
  const growthBook = useGrowthBook()

  if (i18n.language !== 'cs') {
    return 'all'
  }

  return growthBook.evalFeature('onboarding_media_logos')?.value === 'cz'
    ? 'cz'
    : 'all'
}
